<template>
    <Dialog
        modal
        v-model:visible="isVisible"
        :header="title"
        :style="{ width: sizeWidth }"
        :showHeader="isHeaderVisible"
        :closeOnEscape="closeOnEscape"
        :closable="closable"
        :draggable="draggable"
        @update:visible="() => $emit('closed', $event)"
        :pt="{
            pcCloseButton: {
                root: 'px-0 w-8 h-8 flex items-center justify-center hover:bg-gray-100 transition-colors duration-150 ease-in-out rounded-full min-w-8',
            },
        }"
    >
        <template #header>
            <slot name="header" />
        </template>

        <slot />
        <template
            v-if="$slots.footer"
            #footer
        >
            <slot name="footer" />
        </template>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';

export default {
    components: {
        Dialog,
    },
    emits: ['closed'],
    props: {
        title: {
            type: String,
            default: null,
        },
        visible: {
            type: Boolean,
            default: true,
        },
        size: {
            type: String,
            default: 'md',
        },
        closable: {
            type: Boolean,
            default: true,
        },
        closeOnEscape: {
            type: Boolean,
            default: true,
        },
        draggable: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        sizeWidth() {
            switch (this.size) {
                case 'xs':
                    return '300px';
                case 'sm':
                    return '456px';
                default:
                case 'md':
                    return '648px';
                case 'lg':
                    return '800px';
                case 'xl':
                    return '1140px';
            }
        },
        isVisible: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit('update:visible', value);
            },
        },
        isHeaderVisible() {
            return this.title !== null;
        },
    },
};
</script>

<style>
[data-pc-name='pcclosebutton'] {
    width: auto;
    min-width: 2.5rem;
    padding: 0.5rem;
    border-radius: 0.25rem;
}
</style>
